import BaseEntity from './BaseEntity';
import ToolIssue from './ToolIssue';
export default class Tool extends BaseEntity {
    constructor(data) {
        super();
        this.issues = this.parseProperty(data, 'issues').map(issue => new ToolIssue(issue));
        this.name = this.parseProperty(data, 'name');
    }
}
